<template>
  <v-container fluid grid-list-lg>
    <v-layout wrap row>
      <v-flex xs10>
        <v-text-field v-model="cnpj.cnpj" label="CNPJ" autofocus>
        </v-text-field>
      </v-flex>
      <v-flex xs2>
        <v-tooltip bottom>
          <v-btn slot="activator" color="primary" fab small dark @click="searchCnpj();">
            <v-icon>search</v-icon>
          </v-btn>
          <span>Buscar CNPJ</span>
        </v-tooltip>
      </v-flex>
    </v-layout>

    <v-layout v-if="isValidCnpj" wrap row>
      <v-flex xs12>
        <v-text-field v-model="validCnpj.nome" label="Razão Social"></v-text-field>
      </v-flex>
      <v-flex xs12>
        <v-text-field v-model="validCnpj.fantasia" label="Nome Fantasia"></v-text-field>
      </v-flex>
      <v-flex xs12>
        <v-text-field v-model="validCnpj.logradouro" label="Logradouro"></v-text-field>
      </v-flex>
      <v-flex xs12>
        <v-text-field v-model="validCnpj.numero" label="Número"></v-text-field>
      </v-flex>
      <v-flex xs12>
        <v-text-field v-model="validCnpj.complemento" label="Complemento"></v-text-field>
      </v-flex>
      <v-flex xs12>
        <v-text-field v-model="validCnpj.cep" label="Cep"></v-text-field>
      </v-flex>
      <v-flex xs12>
        <v-text-field v-model="validCnpj.bairro" label="Bairro"></v-text-field>
      </v-flex>
      <v-flex xs12>
        <v-text-field v-model="validCnpj.municipio" label="Município"></v-text-field>
      </v-flex>
      <v-flex xs12>
        <v-text-field v-model="validCnpj.uf" label="Uf"></v-text-field>
      </v-flex>
      <v-flex xs12>
        <v-text-field v-model="validCnpj.email" label="E-mail"></v-text-field>
      </v-flex>
      <v-flex xs12>
        <v-text-field v-model="validCnpj.telefone" label="Telefone"></v-text-field>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import PersonService from '../service/PersonService';

  export default {

    data: () => {
      return {
        isValidCnpj: false,
        cnpj: {},
        validCnpj: {},
      }
    }, //data

    methods: {
      async searchCnpj() {
        let validCnpj = await PersonService.searchCnpj(this.cnpj);
        if (validCnpj) {
          this.validCnpj = validCnpj;
          this.isValidCnpj = true;
          console.log(this.validCnpj);
        }
      }, //searchCnpj()
    }, //methods
  } // export default

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/LegalPersonForm.vue